import thienCan from '../data/thien_can.json';
import diaChi from '../data/dia_chi.json';
import { THIEN_CAN_ORDER, DIA_CHI_ORDER } from './canchi_year.js';

const EMPTY_COUNTS = () => ({ Moc: 0, Hoa: 0, Tho: 0, Kim: 0, Thuy: 0 });
export const FIVE_ELEMENT_METHOD = 'tang_can_weighted';
/**
 * Tàng Can weights:
 * - Chính khí (primary): 0.6
 * - Trung khí (middle): 0.3
 * - Dư khí (residual): 0.1
 */
export const TANG_CAN_WEIGHTS = [0.6, 0.3, 0.1];
// Month branch bonus: +0.5 (đương lệnh)
export const MONTH_BRANCH_BONUS = 0.5;

const normalizeCan = (can) => (
  typeof can === 'number' ? THIEN_CAN_ORDER[can] : can
);

const normalizeChi = (chi) => (
  typeof chi === 'number' ? DIA_CHI_ORDER[chi] : chi
);

export const getCanElement = (can) => {
  const key = normalizeCan(can);
  return thienCan[key]?.hanh || null;
};

export const getChiElement = (chi) => {
  const key = normalizeChi(chi);
  return diaChi[key]?.hanh || null;
};

export function countFiveElements(pillars = [], { monthBranch } = {}) {
  const counts = EMPTY_COUNTS();

  pillars.forEach((pillar) => {
    const canElement = getCanElement(pillar.can);
    const chiElement = getChiElement(pillar.chi);
    const tangCanList = pillar.chi_tang_can || diaChi[pillar.chi]?.tang_can || [];

    if (canElement && counts[canElement] !== undefined) {
      counts[canElement] += 1;
    }

    if (chiElement && counts[chiElement] !== undefined) {
      counts[chiElement] += 1;
      if (monthBranch && pillar.chi === monthBranch) {
        counts[chiElement] += MONTH_BRANCH_BONUS;
      }
    }

    tangCanList.forEach((tangCan, index) => {
      const tangElement = getCanElement(tangCan);
      const weight = TANG_CAN_WEIGHTS[index] ?? TANG_CAN_WEIGHTS[TANG_CAN_WEIGHTS.length - 1];
      if (tangElement && counts[tangElement] !== undefined) {
        counts[tangElement] += weight;
      }
    });
  });

  return counts;
}
